<template>
    <div class="slots">
        <div class="card">
			<GameNav v-if="isTablet" class="fields__item"/>
            <div class="card__header">
                <div class="slots__search">
                    <div class="text-field">
						<button class="text-field__btn" @click="reset()" v-if="search && search.trim().length >= 1" type="button">
							<svg class="text-field__btn-icon">
								<use href="#svg-icon-close"></use>
							</svg>
						</button>
                        <input type="text" class="text-field__input" autocomplete="false"
                            placeholder="Введите название игры" v-model="search">
                    </div>
                </div>

                <div class="slots__search-provider-box">
                    <button class="btn btn--lighter-alt" type="button" @click="showProviders = true">
						<img v-if="currentProvider" :src="currentProvider.icon" alt="" class="btn__icon">
                        {{ currentProviderName ? currentProviderName : 'Провайдеры' }}
                    </button>
                </div>
            </div>

            <div class="card__body" v-if="error.show">
                <div class="alert alert--danger">
                    {{ error.text }}
                </div>
            </div>

            <div class="card__body" v-if="!error.show">
                <div class="slots__grid" ref="slots">
                    <div class="slots__item" v-for="game in games" :key="game.id">
                        <img :src="game.image" alt="" class="slots__item-img">
                        <div class="slots__item-badges">
                            <div v-if="game.vpn_required" class="slots__item-badge">VPN</div>
                            <div class="slots__item-badge" :class="{
                                warn: game.wager_multiply > 1,
                                success: game.wager_multiply == 1,
                                danger: game.wager_multiply == 0,
                            }">
                                WAGER X{{game.wager_multiply}}
                            </div>
                        </div>
                        <div v-if="isMobile" class="slots__item-action" @click="getGame(game.id)"></div>
                        <router-link v-else class="slots__item-action"
                            :to="{ name: 'slotsGame', params: { gameId: game.id } }"></router-link>
                    </div>
                </div>

                <Loader class="slots__loader" v-show="loader" :loading="true" static />

                <div class="alert alert--info" v-show="games.length === 0 && !loader">
                    Игры с указанными параметрами не найдены
                </div>
            </div>
        </div>
        <Modal :open-state="showProviders" @close="() => showProviders = false" title="Выберите провайдера"
            dialog-class="modal--lg" class="providers__modal">
			<Providers
				:providers="providers"
				:key="showProviders"
				@setActive="toggleProvider"
				@setAll="refreshResults"
				:active="selectedProvider"
			/>
        </Modal>
    </div>
</template>

<script>
import Modal from "../../components/blocks/Modal.vue";
import { nextTick } from "vue";
import Loader from "../../components/blocks/Loader.vue";
import BreakpointsMixin from "../../mixins/breakpoints-mixin.vue";
import GameNav from "../../components/blocks/GameNav.vue";

export default {
    components: {
        Loader,
        Modal,
		GameNav
    },

	mixins: [
		BreakpointsMixin
	],

    data() {
        return {
            search: null,
            error: {
                show: false,
                message: ''
            },
            games: [],
            providers: [],
            selectedProvider: null,
            page: 1,
            totalPages: 0,
            loader: false,
            delay: null,
            gameId: null,
            isMobile: false,
            showProviders: false,
            observer: null,
            observerItem: null
        }
    },
    computed: {
        category_id: function () {
            return this.$root.$slotegrator[this.$route.name];
        },

        currentProviderName() {
            return this.providers.find(item => item.provider_id === this.selectedProvider)?.provider_name
        },

		currentProvider() {
			return this.providers.find(item => item.provider_id === this.selectedProvider)
		}
    },
    watch: {
        search() {
            if (this.search && this.search.trim().length >= 2 || !this.search) {
                clearTimeout(this.delay);

                this.delay = setTimeout(() => {
                    this.getGames(true);
                }, 750);
            }
        },

        games: {
            async handler() {
                await nextTick()

                if (this.$refs.slots) {
                    this.observerItem = this.$refs.slots.lastElementChild;
                }
            }
        },

        observerItem(newItem, oldItem) {
            if (oldItem) {
                this.observer.unobserve(oldItem);
            }
            this.observer.observe(newItem)

            if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 100) {
                window.scrollBy(0, -100)
            }
        }
    },
    beforeMount() {
        this.getProviders();
    },
    mounted() {
        this.loader = true;
        this.isMobile = this.$isMobile();

        this.observer = new IntersectionObserver(this.observerCallback, {
            rootMargin: "300px",
            threshold: 0.5
        });
        this.getGames();
    },
    methods: {
        applyFilter() {
            this.showProviders = false;
            this.getGames(true);
        },
        toggleProvider(id) {
            if (this.selectedProvider === id) {
                return this.refreshResults();
            }

            this.selectedProvider = id;

            this.applyFilter();
        },
        refreshResults() {
            this.selectedProvider = null;
            this.showProviders = false;
            this.getGames(true);
        },
        observerCallback(entries) {
            if (!entries[0] || !entries[0].isIntersecting || this.loader || this.page >= this.totalPages) {
                return
            }
            this.page += 1;
            this.getGames();
        },
        getProviders() {
            this.$root.axios.post('/api/slots/providers', {
                category_id: this.category_id
            })
                .then(res => {
                    this.providers = res.data;
                }).catch(error => {

                    this.error = {
                        show: true,
                        text: this.$root.graphql.axiosGetError(error)
                    };

                    this.$root.isLoading = false;
                })
        },
        reset() {
            this.search = null;
            this.getGames(true);
        },
        getGames(refresh = false) {
            this.loader = true;

            if (refresh) {
                this.page = 1;
                this.totalPages = 0;
                this.games = [];
            }

            this.$root.axios.post('/api/slots/games', {
                page: this.page,
                category_id: this.category_id,
                search: this.search,
                provider: this.selectedProvider
            })
                .then(res => {
                    const data = res.data;

                    this.$root.isLoading = false;

                    this.loader = false;
                    this.totalPages = data.meta.last_page;
                    this.page = data.meta.current_page;
                    this.games = this.games.concat(data.data);
                }).catch(error => {
                    this.error = {
                        show: true,
                        text: this.$root.graphql.axiosGetError(error)
                    };

                    this.$root.isLoading = false;
                    this.loader = false;
                })
        },
        getGame(gameId) {
            this.isLoading = true;

            this.$root.axios.post('/api/slots/init', {
                game_id: gameId,
                mobile: true
            }).then(res => {
                const data = res.data;
                window.location.href = data?.url?.launch_options?.game_url ?? data?.url;
            }).catch(error => {
                this.error = {
                    show: true,
                    text: this.$root.graphql.axiosGetError(error)
                };

                this.$root.isLoading = false;
            })
        }
    }
}
</script>
